export default class WidgetsHelper {
    filterLoadData(excluded, projects, groups) {
        const summaryProjectIds = projects.filter(item => excluded.indexOf(item.name) === -1).map(item => item.id);
        const summaryGroupIds = groups.filter(item => excluded.indexOf(item.name) === -1).map(item => item.id);
        return { summaryProjectIds, summaryGroupIds };
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/widgets-helper.service.js